export const { default: IconEyeToggle } = require("./IconEyeToggle");
export const { default: IconTrack } = require("./IconTrack");
export const { default: IconPlaylist } = require("./IconPlaylist");
export const { default: IconAlbum } = require("./IconAlbum");
export const { default: IconUser } = require("./IconUser");
export const { default: IconArrowToggle } = require("./IconArrowToggle");
export const { default: IconLogout } = require("./IconLogout");
export const { default: IconDashboard } = require("./IconDashboard");
export const { default: IconPlayToggle } = require("./IconPlayToggle");
export const { default: IconApproveToggle } = require("./IconApproveToggle");
export const { default: IconPrevSong } = require("./IconPrevSong");
export const { default: IconNextSong } = require("./IconNextSong");
export const { default: IconSpeaker } = require("./IconSpeaker");
export const { default: IconBin } = require("./IconBin");
export const { default: IconEdit } = require("./IconEdit");
export const { default: IconUpload } = require("./IconUpload");
export const { default: IconMore } = require("./IconMore");
export const { default: IconHome } = require("./IconHome");
